// Where to send the browser after the active organization changes. A page
// scoped to one org (a course editor, a lesson) means nothing in another, so
// each org-scoped area falls back to its own root; an org-only screen has no
// "All organizations" form, so it lands on the cross-org course list instead.
// `all` is an app admin's "All organizations", `mine` an owner/admin's "All my
// orgs" — which has no org list and no settings of its own.
// Client-safe: no server imports.

export type OrgSelection = 'all' | 'mine' | 'org'

export function landingAfterOrgSwitch(pathname: string, selection: OrgSelection): string {
  const area = `/${pathname.split('/')[1] ?? ''}`
  switch (area) {
    case '/courses':
      return '/courses'
    case '/organization':
    case '/organizations':
      if (selection === 'mine')
        return '/courses'
      return selection === 'all' ? '/organizations' : '/organization'
    case '/questions':
      return selection === 'org' ? area : '/courses'
    case '/settings':
      // A storefront may keep app-admin tabs here for "All organizations"
      // (ASCPS' membership price); one that has none redirects on its own.
      return selection === 'mine' ? '/courses' : '/settings'
    case '/learn':
      return '/learn'
    default:
      return pathname
  }
}
